import React, { FC, useEffect } from 'react';
import { LandscapeAboutParticipantsTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { fetchLandscapeById } from '../../../store/landscapeAPI/landscape/reducers/landscape.slice';
import { useNavigate, useParams } from 'react-router-dom';
import Spinner from '../../atoms/Spinner/Spinner';
import { deleteParticipant } from '../../../store/landscapeAPI/participant/reducers/participant.slice';
import cn from 'classnames';
import styles from './LandscapeAboutParticipantPage.module.css';
import { LocalesLanguagesConstants } from '../../../locales/locales';

interface LandscapeAboutParticipantPageProps {}

const LandscapeAboutParticipantPage: FC<
  LandscapeAboutParticipantPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id } = useParams();
  const { landscape, status } = useSelector(
    (state: RootState) => state.landscapeSlice
  );
  const { status: participantStatus } = useSelector(
    (state: RootState) => state.participantSlice
  );

  useEffect(() => {
    if (id) {
      dispatch(
        fetchLandscapeById({ id: id, language: LocalesLanguagesConstants.en })
      );
    }
  }, [dispatch, id]);

  const handleEdit = (participantId: string) => {
    navigate(`/landscapes/edit/${id}/about/participant/edit/${participantId}`);
  };

  const handleDelete = async (participantId: string) => {
    if (id) {
      await dispatch(
        deleteParticipant({ existingId: participantId, compactId: id })
      );
      dispatch(
        fetchLandscapeById({ id: id, language: LocalesLanguagesConstants.en })
      );
    }
  };

  if (status === 'loading' || participantStatus === 'loading') {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.landscapeAboutParticipantWrapper)}>
      <LandscapeAboutParticipantsTemplate
        participants={landscape?.participants ?? []}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
      />
    </div>
  );
};

export default LandscapeAboutParticipantPage;
